export class ClientRequestedSoftwareTypes {
  public id: number;
  public requestedWaiters: number = 0;
  public requestedCashRegisters: number = 0;
  public requestedMainDevice: number = 0;

  static fromDto(c, existingSoftwareTypes: ClientRequestedSoftwareTypes): ClientRequestedSoftwareTypes {
    const clientRequestedSoftwareTypes = new ClientRequestedSoftwareTypes();
    if (!c) {
      return null;
    }
    clientRequestedSoftwareTypes.id = c.id;
    clientRequestedSoftwareTypes.requestedWaiters = c.requestedWaiters;
    clientRequestedSoftwareTypes.requestedCashRegisters = c.requestedCashRegisters;
    clientRequestedSoftwareTypes.requestedMainDevice = c.requestedMainDevice;
    return clientRequestedSoftwareTypes;
  }

}
